// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-checkbox[data-v-3ed40350] {\n.el-form-item__content {\n.el-checkbox {\n.el-checkbox__label {\n        font-size: 14px !important;\n        color: #555 !important;\n}\n}\n}\n}\n", ""]);
// Exports
module.exports = exports;
